module.exports = __webpack_public_path__ + "static/img/12.89e6dccd.png";